import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-audit-detail-dialog',
  templateUrl: './audit-detail-dialog.component.html',
})
export class AuditDetailDialogComponent {
  selectedEvent: any;

  constructor(
    public dialogRef: MatDialogRef<AuditDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.selectedEvent = data && data.mode === 'sequence'
      ? ((data.events || [])[0] || null)
      : data.event;
  }

  selectEvent(event: any) {
    this.selectedEvent = event;
  }

  requestSequence() {
    if (this.selectedEvent && this.selectedEvent.request_id) {
      this.dialogRef.close({ requestId: this.selectedEvent.request_id });
    }
  }

  formatJson(value: any) {
    if (!this.hasData(value)) return '-';
    return JSON.stringify(value, null, 2);
  }

  hasData(value: any) {
    return value && typeof value === 'object' && Object.keys(value).length > 0;
  }

  statusLabel(value: string) {
    const labels: any = { success: 'Sucesso', blocked: 'Bloqueado', failed: 'Falha' };
    return labels[value] || value || 'Registrado';
  }

  riskLabel(value: string) {
    const labels: any = {
      destructive_action: 'Ação destrutiva',
      bulk_action: 'Operação em massa',
      request_failed: 'Requisição com erro',
      request_exception: 'Exceção técnica',
      master_required: 'Master obrigatório',
      first_observed_login: 'Primeiro login observado',
      new_ip: 'Novo IP',
      new_user_agent: 'Novo dispositivo',
      repeated_failed_logins: 'Falhas de login repetidas',
      success_after_repeated_failures: 'Sucesso após falhas',
      repeated_rejected_token: 'Token rejeitado repetidamente',
      same_token_multiple_ips: 'Token usado em múltiplos IPs',
      token_missing: 'Token ausente',
      token_invalid: 'Token inválido',
      token_expired: 'Token expirado',
      token_user_not_found: 'Usuário do token não encontrado',
      possible_account_targeting: 'Possível tentativa contra outra conta',
      delete_target_user_mismatch: 'ID solicitado difere do usuário autenticado',
      delete_target_email_mismatch: 'Email solicitado difere do usuário autenticado',
      support_required: 'Exclusão disponível somente pelo suporte',
    };
    return labels[value] || value;
  }
}
